var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSideBar(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 17,
    viewBox: "0 0 19 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.6406 8.25L8.64062 4.25V7.25H0.640625V9.25H8.64062V12.25M18.6406 14.25V2.25C18.6406 1.71957 18.4299 1.21086 18.0548 0.835786C17.6798 0.460714 17.1711 0.25 16.6406 0.25H4.64062C4.11019 0.25 3.60148 0.460714 3.22641 0.835786C2.85134 1.21086 2.64062 1.71957 2.64062 2.25V5.25H4.64062V2.25H16.6406V14.25H4.64062V11.25H2.64062V14.25C2.64062 14.7804 2.85134 15.2891 3.22641 15.6642C3.60148 16.0393 4.11019 16.25 4.64062 16.25H16.6406C17.1711 16.25 17.6798 16.0393 18.0548 15.6642C18.4299 15.2891 18.6406 14.7804 18.6406 14.25Z",
    fill: "#9C4900"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSideBar);
export default __webpack_public_path__ + "static/media/sideBar.4a98138e930e06972088597bd9a676c4.svg";
export { ForwardRef as ReactComponent };